import { ProDetailList } from '@bedrock/eed-react';
import {
  FormCard,
  FormItemBaseEnum,
  FormItemBaseFile,
  FormModule,
  SupplierDetailList,
} from '@purchase/supplier';
import React, { useMemo } from 'react';
import { get } from 'lodash-es';
import { ProTextEllipsis } from '../../components/ProTextEllipsis';

export const TechnicalCapabilities = (props: {
  namePath?: string[];
  mode?: 'card' | 'module';
  formItemProps?: any;
  formDetail?: any;
}) => {
  const { namePath = [], mode = 'module', formItemProps, formDetail } = props;
  const Wrapper = mode === 'card' ? FormCard : FormModule;
  const techCount = useMemo(
    () =>
      get(formDetail, [
        ...namePath,
        'extendAttributeInfo',
        'technicalCapability',
      ])?.length ?? 0,
    [formDetail, namePath]
  );

  return (
    <Wrapper
      title="技术能力"
      titleCount={techCount}
      proCardProps={{ expandable: true, defaultExpanded: techCount > 0 }}
    >
      <SupplierDetailList
        span={2}
        name={[...namePath, 'extendAttributeInfo', 'technicalCapability']}
        fieldProps={{ scroll: { x: 1120 } }}
        formItemProps={formItemProps}
      >
        <ProDetailList.Item
          label="#"
          name="#"
          meta={{ columnProps: { width: 50, fixed: true } }}
        >
          {(value, record, index) => {
            return index + 1;
          }}
        </ProDetailList.Item>
        <ProDetailList.Item
          label="技术类型"
          name="technologyType"
          meta={{
            columnProps: { width: 200, className: 'font-semibold', fixed: true },
          }}
        >
          <FormItemBaseEnum />
        </ProDetailList.Item>
        <ProDetailList.Item label="技术描述" name="technicalAbilityDescription">
          <ProTextEllipsis />
        </ProDetailList.Item>

        <ProDetailList.Item
          label="附件"
          name="technicalAttachment"
          meta={{ columnProps: { width: 240 } }}
        >
          <FormItemBaseFile />
        </ProDetailList.Item>
      </SupplierDetailList>
    </Wrapper>
  );
};
